import { CategoryId, DistributorId } from "./Product";

export interface ProductStatisticFilters {
  dateRange?: ReadonlyArray<Date>;
  daysBack: number;
  tenantIds: ReadonlyArray<string>;
  storeId: string;
  categoryIds: ReadonlyArray<CategoryId>;
  distributorIds: ReadonlyArray<DistributorId>;
  brandNames: ReadonlyArray<string>;

  showColumnSold: boolean;
  showColumnOnShelf: boolean;
  showColumnInStorage: boolean;
  showColumnDfp: boolean;
  showArticleNumber: boolean;
  showPrio: boolean;
}

export const initialProductStatisticFilters: ProductStatisticFilters = {
  daysBack: 1,
  tenantIds: [],
  storeId: "",
  categoryIds: [],
  distributorIds: [],
  brandNames: [],
  showColumnSold: true,
  showColumnOnShelf: true,
  showColumnInStorage: true,
  showColumnDfp: true,
  showArticleNumber: true,
  showPrio: true
};

export interface ProductSyncFilters {
  storeIds: ReadonlyArray<string>;
  priorityIds: ReadonlyArray<number>;
  categoryIds: ReadonlyArray<CategoryId>;
  hideMaxOnShelf: boolean;
  hideOrderThreshold: boolean;
  hideArticleNumber: boolean;
  hideLatestPurchase: boolean;
  productFilter: number;
}

export const initialProductSyncFilters: ProductSyncFilters = {
  storeIds: [],
  priorityIds: [],
  categoryIds: [],
  hideMaxOnShelf: false,
  hideOrderThreshold: false,
  hideArticleNumber: false,
  hideLatestPurchase: false,
  productFilter: 1
};
